<div class="employee-basket-view">
  @if (isPbEnabled()) {
    <flexyoo-employee-pb-basket-info></flexyoo-employee-pb-basket-info>
  }
  @if (isSsEnabled()) {
    <flexyoo-employee-ss-basket-info></flexyoo-employee-ss-basket-info>
  }
  @if (isCartMode()) {
    <flexyoo-employee-basket-prior-year-payments></flexyoo-employee-basket-prior-year-payments>
    @if (hasCart()) {
      <flexyoo-employee-basket-cart-management
        [isCartSigningOpen]="isCartSigningOpen()"
        [selectedBenefitId]="selectedBenefitId()"
        (refresh)="refresh.emit()"
        (removeBenefit)="onRemoveBenefit($event)"
        (signBenefit)="onSignBenefit($event)"
        (signCart)="onSignCart($event)"
      />
    }
    <flexyoo-employee-basket-cart-archive
      (signBenefit)="onSignBenefit($event)"
      (signCart)="onSignCart($event)"
    ></flexyoo-employee-basket-cart-archive>
  } @else {
    <flexyoo-employee-current-benefits
      [selectedBenefitId]="selectedBenefitId()"
      (signBenefit)="onSignBenefit($event)"
    />
    <flexyoo-employee-basket-cart
      [selectedBenefitId]="selectedBenefitId()"
      (removeBenefit)="onRemoveBenefit($event)"
      (signBenefit)="onSignBenefit($event)"
    />
  }
</div>
